module.exports = __webpack_public_path__ + "anexar.png?6970a37041b50bee2a48f7015860ad86";


//////////////////
// WEBPACK FOOTER
// ./src/assets/anexar.png
// module id = 669
// module chunks = 0 2 7 8 9 10